import { render, staticRenderFns } from "./marketingShare.vue?vue&type=template&id=2e52cc30&"
import script from "./marketingShare.vue?vue&type=script&lang=js&"
export * from "./marketingShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports